import Login from "../../../../jsx/pages/Connector/Login";

const LoginWrapper = function (props) {
  return <Login />;
};

export default constore(LoginWrapper);
